class ScrollTop {
    constructor(element) {
        this.element = element;

        this.switchScrollButton();
        this.initEvents();
    }

    initEvents() {
        this.element.addEventListener('click', (event) => {
            event.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        });
        window.addEventListener('scroll', () => this.switchScrollButton(ScrollTop.getViewportOffset()));
    }

    static getViewportOffset() {
        return Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0) / 2;
    }

    switchScrollButton(offset) {
        if (window.pageYOffset >= offset) {
            this.element.removeAttribute('hidden');
        } else {
            this.element.setAttribute('hidden', true);
        }
    }
}

export default () => {
    const element = document.querySelector('.js-scrolltop');

    if (!element) {
        return false;
    }

    return new ScrollTop(element);
};
